import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class AdministratorActions extends Actions{
    static get target(){
        return 'administrators'
    }
}


// WEBPACK FOOTER //
// ./actions/AdministratorActions.js